var _path, _path2, _path3, _path4, _line, _line2, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalEarnings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 66,
    viewBox: "0 0 89 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1666 1H3.36301C2.05795 1 1 2.05156 1 3.34873V62.6513C1 63.9484 2.05795 65 3.36301 65H86.1666C87.4716 65 88.5296 63.9484 88.5296 62.6513V3.34873C88.5296 2.05156 87.4716 1 86.1666 1Z",
    stroke: "#733FE7",
    strokeWidth: 0.66154,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L74 16",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L73 47",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6848 7.60242H9.60156C8.49699 7.60242 7.60156 8.44605 7.60156 9.48672V57.063C7.60156 58.1036 8.49699 58.9473 9.60156 58.9473H79.6848C80.7894 58.9473 81.6848 58.1036 81.6848 57.063V9.48672C81.6848 8.44605 80.7894 7.60242 79.6848 7.60242Z",
    stroke: "#733FE7",
    strokeWidth: 2.93399,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.91,
    y1: 32,
    x2: 32.91,
    y2: 52,
    stroke: "#733FE7",
    strokeWidth: 1.82
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.91,
    y1: 32,
    x2: 64.91,
    y2: 52,
    stroke: "#733FE7",
    strokeWidth: 1.82
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.91,
    y: 32.91,
    width: 24.18,
    height: 18.18,
    stroke: "#733FE7",
    strokeWidth: 1.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.91,
    y: 21.91,
    width: 56.18,
    height: 5.18,
    stroke: "#733FE7",
    strokeWidth: 1.82
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.91,
    y: 32.91,
    width: 24.18,
    height: 18.18,
    stroke: "#733FE7",
    strokeWidth: 1.82
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalEarnings);
export default __webpack_public_path__ + "static/media/personal-earnings.677cd0fb.svg";
export { ForwardRef as ReactComponent };